// React Query logs failed queries and mutations with the raw error. An Axios error
// carries its request config (Authorization header, request body with link tokens),
// so only a summary of it may reach the console.
const isHttpError = (value) =>
  Boolean(value && typeof value === 'object' && (value.isAxiosError || value.config));

export const summarize = (value) => {
  if (!isHttpError(value)) {
    return value;
  }
  const status = value.response?.status;
  return `${value.name || 'Error'}${status ? ` ${status}` : ''}: ${value.message || ''}`;
};

const sanitized =
  (method) =>
  (...args) =>
    // eslint-disable-next-line no-console
    console[method](...args.map(summarize));

export const queryLogger = {
  log: sanitized('log'),
  warn: sanitized('warn'),
  error: sanitized('error'),
};
